import { useTranslation } from 'react-i18next'
import { useSelectedOffer } from '@/features/priceCalculator/PurchaseForm/useSelectedOffer'
import { Text } from 'ui/src/components/Text/Text'
import { root } from './ProductSpecs.css'

// Accident and Payment Protection insurances don't include deductible nor addon and their
// exposure don't add that much value.
const PRODUCTS_WITHOUT_SPECS = ['SE_ACCIDENT', 'SE_PAYMENT_PROTECTION']

export function ProductSpecs() {
  const { t } = useTranslation('purchase-form')
  const [selectedOffer] = useSelectedOffer()

  //We also just want to show the specs when the user is on the viewOffers step.
  const hideSpecs = !selectedOffer || PRODUCTS_WITHOUT_SPECS.includes(selectedOffer.product.name)
  if (hideSpecs) {
    return null
  }

  const displayItemKeys = ['numberCoInsured', 'breeds', 'mileage'] as const

  const specs = [
    { value: selectedOffer.exposure.displayNameShort },
    ...displayItemKeys.map((key) => ({
      value: selectedOffer.displayItems.find((item) => item.key === key)?.displayValue ?? null,
    })),
    {
      value: selectedOffer.deductible?.displayName
        ? t('PRODUCT_SPECS_DEDUCTIBLE_LABEL', { amount: selectedOffer.deductible.displayName })
        : null,
    },
  ].filter((spec) => spec.value !== null)

  return (
    <div className={root}>
      {specs.map((spec, index) => (
        <Text key={index} color="textSecondary" size="xs">
          {spec.value}
        </Text>
      ))}
    </div>
  )
}
